class WhyNotAdd extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.initialise()
  }

  async initialise () {
    if (this?.dataset?.itemCount === '0' && this.itemsEl) {
      const whyNotAddHTML = await this.fetchRecommendations()
      const whyNotAddDom = window.BAO.sectionRenderer.convertToDOM(
        whyNotAddHTML,
      )
      const whyNotAddItemsEl = window.BAO.Utils.getElement(
        this.els.items.selector,
        {
          context: whyNotAddDom,
        },
      )
      this.isHidden = !whyNotAddItemsEl?.innerHTML?.length
      this.itemsEl.innerHTML = whyNotAddItemsEl.innerHTML
    }
  }

  async fetchRecommendations () {
    const response = await fetch(`${this.recommendationsUrl}?${this.params}`)
    const text = await response.text()
    return this.sectionRenderer.getInnerHtml(text)
  }

  get hasCompleteTheSet () {
    /* Checks if the complete-the-set element exists in the dom */
    return !!window.BAO.Utils.getElement('complete-the-set', {
      context: document,
    })
  }

  get isHidden () {
    return this.getAttribute(this.hiddenAttribute) === 'true'
  }

  set isHidden (boolean) {
    this.setAttribute(this.hiddenAttribute, boolean.toString())
  }

  get hiddenAttribute () {
    return `aria-hidden`
  }

  get itemsEl () {
    return this?.els?.items?.element
  }

  get recommendationsUrl () {
    return this.dataset?.recommendationsUrl
  }

  get productId () {
    return this.dataset?.productId
  }

  get sectionId () {
    return this.dataset?.sectionId
  }

  get params () {
    // eslint-disable-next-line compat/compat
    const params = new URLSearchParams()
    params.set('product_id', this.productId)
    params.set('section_id', this.sectionId)
    params.set('limit', 6)
    return params.toString()
  }

  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }
}

if (!customElements.get('why-not-add')) {
  customElements.define('why-not-add', WhyNotAdd)
}

class WhyNotAddForm extends window.BAO.ProductForm {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners() {
    if (this.listenersInitialized) return
    this.listenersInitialized = true
  
    window.setTimeout(() => {
      super.setupListeners()
      if (!this.formEl || !this.selectEl || !this.labelEl || !this.buttonEls) {
        return
      }
      this.listeners.add(
        this.formEl,
        'change',
        this.handleFormChange.bind(this),
      )
    }, 500)
  }

  handleFormChange (event) {
    if (!event.target.closest(this?.form?.localName)) return
    const optionEl = this.selectEl.options[this.selectEl.selectedIndex]
    this.labelEl.textContent = optionEl.textContent
    this.buttonEls.forEach(buttonEl => {
      buttonEl.disabled = !(
        this.selectEl.value && this.selectEl.value.length > 0
      )
    })
  }

  get formEl () {
    return this?.form
  }

  get selectEl () {
    return this?.els?.select?.element
  }

  get labelEl () {
    return this?.els?.label?.element
  }

  get buttonEls () {
    return this?.els?.button?.elements
  }
}

if (!customElements.get('why-not-add-form')) {
  customElements.define('why-not-add-form', WhyNotAddForm)
}
